var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.033,
    y: 32.748,
    width: 3.49,
    height: 3.35,
    fill: "currentColor",
    strokeWidth: "0px"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.025,16.431h0c-.664-.664-1.83-.664-2.494,0-.33.329-.498.749-.498,1.247v12.458h3.49v-12.458c0-.498-.168-.918-.498-1.247Z",
    fill: "currentColor",
    strokeWidth: "0px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.701,43.697h-.047l-27.768-.123c-2.739-.012-4.919-1.082-5.978-2.938-1.06-1.854-.876-4.273.504-6.639l13.99-23.986c1.375-2.359,3.383-3.709,5.51-3.709h.022c2.135.01,4.14,1.379,5.499,3.756l13.777,24.107c1.359,2.379,1.521,4.803.445,6.646-1.069,1.836-3.239,2.885-5.956,2.885ZM24.913,9.803c-.85,0-1.755.717-2.486,1.971v.002l-13.99,23.986c-.733,1.256-.911,2.4-.489,3.139.423.74,1.5,1.168,2.955,1.174l27.768.123h.033c1.438,0,2.506-.418,2.932-1.146.429-.736.261-1.883-.462-3.146l-13.777-24.107c-.722-1.264-1.624-1.99-2.476-1.994h-.007Z",
    fill: "currentColor",
    strokeWidth: "0px"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWarning);
export default __webpack_public_path__ + "static/media/icn-warning.36d4e2c122ca9e430c653be28162d714.svg";
export { ForwardRef as ReactComponent };